import moment from 'moment';

export default (() => {

    $('.book-a-table-widget .date-picker-single')
    .daterangepicker({
                        autoApply: true,
                        showDropdowns: false,
                        singleDatePicker: true,
                        opens: 'center',
                        minDate: new Date(),
                        locale: {
                          format: 'DD/MM/YYYY',
                          'daysOfWeek': [
                            'Sun',
                            'Mon',
                            'Tue',
                            'Wed',
                            'Thu',
                            'Fri',
                            'Sat',
                        ],
                        'monthNames': [
                            'January',
                            'February',
                            'March',
                            'April',
                            'May',
                            'June',
                            'July',
                            'August',
                            'September',
                            'October',
                            'November',
                            'December',
                        ],
                        firstDay: 1,
                      },
                      startDate: moment(),
                    })
    



    $('.book-a-table-widget button.submit').click(function(e) {
        e.preventDefault();

        let parent = $(this).parents('.book-a-table-widget'),
            date = parent.find('.date-picker-single').data('daterangepicker').startDate.format('YYYY-MM-DD'),
            preferredTime = parent.find('.preferred-time').val(),
            numberOfPeople = parent.find('.number-people').val(),
            restaurantId = parent.data('id'),
            restaurantReference = parent.data('reference'),
            type = parent.data('type');
        
    
        if (!date || !preferredTime || !numberOfPeople)
        {
          return;
        }

        let url = '';

        if(type == 'open-table') {
          url = `http://www.opentable.com.au/restaurant/profile/${restaurantId}/reserve?restref=${restaurantId}&datetime=${date}T${preferredTime}&covers=${numberOfPeople}&searchdatetime=${date}T${preferredTime}&partysize=${numberOfPeople}`;
        } else if (type == 'fork') {
          var time = moment(preferredTime, 'hh:mm:ss');
          url =  `https://www.thefork.com.au/make-booking/${restaurantReference}?mode=Widget&date=${date}T${time.format('HH:mm:ss')}&Covers=${numberOfPeople}`;
        }

        window.open(
          url,
          '_blank'
        );
      });
});



// WEBPACK FOOTER //
// ./scripts/components/book-a-table.js